import { formatDistanceToNow } from "date-fns";
import { useTranslation } from "react-i18next";

interface RelativeTimeProps {
  iso: string | null | undefined;
  fallbackKey?: string;
  fallbackNs?: string;
}

export function RelativeTime({
  iso,
  fallbackKey = "list.neverLoggedIn",
  fallbackNs = "admin-users",
}: RelativeTimeProps) {
  const { t } = useTranslation(fallbackNs);
  if (!iso) {
    return <span className="text-muted-foreground">{t(fallbackKey)}</span>;
  }
  const date = new Date(iso);
  if (Number.isNaN(date.valueOf())) {
    return <span className="text-muted-foreground">{t(fallbackKey)}</span>;
  }
  return (
    <time dateTime={iso} title={date.toLocaleString()}>
      {formatDistanceToNow(date, { addSuffix: true })}
    </time>
  );
}
